import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.8891 6.64424H13.1024L12.9186 14.3706H11.0729L10.8891 6.64424ZM12.9665 18.0461C12.7268 18.2751 12.4046 18.3896 11.9997 18.3896C11.5949 18.3896 11.2726 18.2751 11.0329 18.0461C10.7932 17.8117 10.6734 17.5027 10.6734 17.1192C10.6734 16.7304 10.7932 16.4214 11.0329 16.1924C11.2726 15.958 11.5949 15.8408 11.9997 15.8408C12.4046 15.8408 12.7268 15.958 12.9665 16.1924C13.2062 16.4214 13.3261 16.7304 13.3261 17.1192C13.3261 17.5027 13.2062 17.8117 12.9665 18.0461Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.2275 3.13997L14.5225 3.4091L14.9162 3.34217L17.8889 2.8367L18.664 5.75077L18.7667 6.13665L19.134 6.29316L21.9081 7.47512L20.9847 10.3457L20.8624 10.7258L21.0869 11.056L22.7816 13.5502L20.4528 15.4658L20.1445 15.7195L20.1547 16.1186L20.232 19.133L17.2372 19.4856L16.8407 19.5322L16.6335 19.8736L15.0688 22.4512L12.3588 21.1287L12 20.9536L11.6412 21.1287L8.93124 22.4512L7.36652 19.8736L7.15933 19.5322L6.76277 19.4856L3.76804 19.133L3.8453 16.1186L3.85553 15.7195L3.54717 15.4658L1.21843 13.5502L2.91314 11.056L3.13755 10.7258L3.01528 10.3457L2.09189 7.47512L4.86599 6.29316L5.23333 6.13665L5.33597 5.75077L6.1111 2.8367L9.08384 3.34217L9.47748 3.4091L9.77245 3.13997L12 1.10756L14.2275 3.13997Z",
		stroke: "currentColor",
		strokeWidth: 1.63636,
		strokeMiterlimit: 16,
		strokeLinecap: "round"
	})]
});
export default SvgNew;
